import React from 'react';

import './TranscriptionLoader.less';

export default function TranscriptionLoader() {
  return (
    <div className="media_viewer_transcription-loader">
      <div className="media_viewer_transcription-loader-icon">
        <svg
          width="98"
          height="98"
          viewBox="0 0 100 100"
          style={{ transform: 'rotate(-90deg)' }}
        >
          <circle
            cx="50"
            cy="50"
            r="48"
            stroke="#fff"
            strokeOpacity="0.11"
            strokeWidth="4"
            fill="none"
          />
          <circle
            cx="50"
            cy="50"
            r="48"
            stroke="#3553DB"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
            strokeDasharray="60 251"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 50 50"
              to="360 50 50"
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
      <div className="media_viewer_transcription-loader-title">
        Generating transcription…
      </div>
      <div className="media_viewer_transcription-loader-text">
        <p>
          Processing time may vary based on the length of the media. You can
          close this panel while the transcription is being generated.
        </p>{' '}
        <p>We’ll notify you when it’s ready.</p>
      </div>
    </div>
  );
}
